module.exports = __webpack_public_path__ + "img/googleplay-bg.db14b824.svg";